<template>
  <div class="qr-box" v-if="visible">
    <div class="text">
      <div class="text-item" v-for="v, i in text" :key="i">{{v}}</div>
    </div>
    <div class="content">
      <img :src="QRImage" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: Array,
      default () {
        return ['', '']
      }
    },
    id: {
      type: [String, Number],
      default: ''
    },
    isCheckWorksCount: {
      type: Boolean,
      default: true
    }
    // visible: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      QRImage: '',
      visible: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.showQRImage();
      }
    }
  },
  created() {
    this.showQRImage();
    window.addEventListener('wlqr', () => {
      this.showQRImage();
    });
  },
  methods: {
    getQRData () {
      return new Promise(resolve => {
        window.wlQrcodeCustomComp.getQrCodeUrl(
          { wl_qrcode_id: this.id,},
          (data) => {
            console.log(`Turbo ~ getQRData ~ data`, data)
            resolve(data);
          }
        );
      })
    },
    async updateQRData () {
      // const data = await this.getQRData();
    },
    async showQRImage() {
      if (this.isCheckWorksCount) {
        await this.ifShowQR();
      } else {
        this.visible = true;
      }
      const list = (window.wlQrcodeCustomComp || {}).list || [];
      const item = list.find(v => v.id === this.id);
      if (item) {
        this.QRImage = item.data.data.qr_code;
      }
    },
    async ifShowQR() {
      const resp = await this.$http.get('/api/user/limit?type=draft-work-transform');
      const {code, data} = resp.data;
      const worksEmpty = code === 200 && data && data.work.num === 0;
      this.visible = worksEmpty;
    }
  }
}
</script>

<style lang="scss" scoped>
.qr-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 132px;
  height: 173px;
  background-color: #fff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, .16);
}
.text {
  margin-bottom: 12px;
  font-weight: bold;
  line-height: 18px;
  color: #2E2E2E;
  font-size: 14px;
  .text-item {
    width: 100%;
    text-align: center;
  }
}
.content {
  width: 96px;
  height: 96px;
  .img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/qr.vue